@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if (
    !$.row.restricted_to_eligible_clients &&
    !$.row.restricted_to_eligible_service_products_category &&
    !$.row.restricted_to_eligible_plan_products_category &&
    !$.row.restricted_to_eligible_organisations
  ) {
    <div>
      {{ 'ADMIN.COUPON.NOT_RESTRICTED' | translate }}
    </div>
  } @else {
    @if ($.row.restricted_to_eligible_clients) {
      <span class="cursor-pointer text-primary" (click)="GetClients($.row)">
        {{
          $.row.client_restricted == 1
            ? ('ADMIN.COUPON.CLIENT_COUNT'
              | translate: { count: $.row.client_restricted })
            : ('ADMIN.COUPON.CLIENTS_COUNT'
              | translate: { count: $.row.client_restricted })
        }}
      </span>
    }
    @if ($.row.restricted_to_eligible_clients) {
      <br />
    }
    @if ($.row.restricted_to_eligible_service_products_category) {
      <span class="cursor-pointer text-primary" (click)="addServices($.row)">
        {{
          $.row.service_restricted == 1
            ? ('ADMIN.COUPON.PRODUCT_COUNT'
              | translate: { count: $.row.service_restricted })
            : ('ADMIN.COUPON.PRODUCTS_COUNT'
              | translate: { count: $.row.service_restricted })
        }}
      </span>
    }
    @if ($.row.restricted_to_eligible_service_products_category) {
      <br />
    }
    @if ($.row.restricted_to_eligible_plan_products_category) {
      <span class="cursor-pointer text-primary" (click)="addPlans($.row)">
        {{
          $.row.plan_restricted == 1
            ? ('ADMIN.COUPON.PLAN_COUNT'
              | translate: { count: $.row.plan_restricted })
            : ('ADMIN.COUPON.PLANS_COUNT'
              | translate: { count: $.row.plan_restricted })
        }}
      </span>
    }
    @if ($.row.restricted_to_eligible_plan_products_category) {
      <br />
    }
    @if ($.row.restricted_to_eligible_organisations) {
      <span
        class="cursor-pointer text-primary"
        (click)="addOrganization($.row)"
      >
        {{
          $.row.organization_restricted == 1
            ? ('ADMIN.COUPON.ORGANIZATION_COUNT'
              | translate: { count: $.row.organization_restricted })
            : ('ADMIN.COUPON.ORGANIZATION_COUNTS'
              | translate: { count: $.row.organization_restricted })
        }}
      </span>
    }
  }
}

@if (addClientsModal | async; as show) {
  <coupon-eligible-clients
    [tenantId]="tenantId"
    [couponMaster]="couponMaster"
    [visible]="show"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    (closeEvent)="closeEvent($event)"
  />
}

@if (addServicessModal | async; as show) {
  <app-coupon-service-restriction
    [tenantId]="tenantId"
    [couponMaster]="couponMaster"
    [visible]="show"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    (closeEvent)="closeEvent($event)"
    [serviceIds]="selectedServiceIds"
  />
}

@if (addPlansModal | async; as show) {
  <coupon-plan-restriction
    [tenantId]="tenantId"
    [couponMaster]="couponMaster"
    [visible]="show"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    (closeEvent)="closeEvent($event)"
    [planIds]="selectedPlanIds"
  />
}

@if (addOrganisationModal | async; as show) {
  <coupon-organization-restriction
    [tenantId]="tenantId"
    [couponMaster]="couponMaster"
    [visible]="show"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    (closeEvent)="closeEvent($event)"
    [organizationIds]="selectedOrganizationIds"
  />
}
